import { graphql } from "generated/gql";

export const BaseMapFieldsFragment = graphql(/* GraphQL */ `
  fragment BaseMapFields on BaseMap {
    id
    name
    url
    attribution
    minZoom
    maxZoom
  }
`);

export const getMapConfigDocument = graphql(/* GraphQL */ `
  query GetMapConfig(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      map {
        key
      }
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        id
        name
        urlSlug
        mapCenterLatitude
        mapCenterLongitude
        mapZoomLevel
        baseMap {
          ...BaseMapFields
        }
      }
    }
  }
`);

export const getCollectionLocationGeometryDocument = graphql(/* GraphQL */ `
  query GetCollectionLocationGeometry(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
    $filter: LocationFilter
    $searchTerm: String
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        name
        locationsGeometry(searchTerm: $searchTerm, filter: $filter)
      }
    }
  }
`);

export const getCollectionGeometryDocument = graphql(/* GraphQL */ `
  query GetCollectionGeometry(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
    $filters: PlantMaterialFilter
    $searchTerm: PlantMaterialsSearchTerm
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        name
        baseMap {
          ...BaseMapFields
        }
        plantMaterialsAsGeoJSON(searchTerm: $searchTerm, filters: $filters)
      }
    }
  }
`);

export const getCollectionGeometryWIthinCircleDocument = graphql(/* GraphQL */ `
  query GetCollectionGeometryWithinCircle(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
    $searchTerm: PlantMaterialsSearchTerm
    $bounds: Circle!
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        name
        plantMaterialsGeometryWithinCircleWIP(
          searchTerm: $searchTerm
          bounds: $bounds
        ) {
          type
          features {
            type
            geometry
            properties {
              adHoc
            }
          }
        }
      }
    }
  }
`);

export const MapMaterialListFieldsFragment = graphql(/* GraphQL */ `
  fragment MapMaterialListFields on PlantMaterial {
    id
    qualifier
    status
    materialGroup
    public
    collectionSiteLocation {
      id
      name
      code
      archived
    }
    position {
      latitude
      longitude
      elevation
    }
    accession {
      accessionNumber
      scientificName
      taxon {
        scientificName
        commonName
        fullyValidated
        nativeDistribution
        sharedScientificName {
          id
          scientificName
          status
          nameSourceUrl
          nameSource
          rank
          authorship
          classification {
            family
          }
          taxon {
            nativeDistribution
            climate
            globalRedListStatus
            lifeForms {
              nodes {
                id
                name
              }
            }
          }
        }
      }
      provenanceCategoryCode
    }
    tagsConnection {
      nodes {
        id
        name
      }
    }
    primaryImage {
      ...MaterialImageFields
    }
    images {
      ...MaterialImageFields
    }
    lastObservation {
      id
      createdAt
      condition
    }
    followUp {
      count
      period
    }
  }
`);

export const getMapListMaterialsDocument = graphql(/* GraphQL */ `
  query MapListMaterials(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
    $orderBy: PlantMaterialsOrderByInput
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filters: PlantMaterialFilter
    $searchTerm: PlantMaterialsSearchTerm
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        total: plantMaterialTotal(filters: $filters, searchTerm: $searchTerm)
        result: plantMaterials(
          orderBy: $orderBy
          before: $before
          after: $after
          first: $first
          last: $last
          filters: $filters
          searchTerm: $searchTerm
        ) {
          nodes {
            ...MapMaterialListFields
          }
          pageInfo {
            ...PageInfoFields
          }
        }
      }
    }
  }
`);
